import Nav from "./landing/Nav";
import Hero from "./landing/Hero";
import Stats from "./landing/Stats";
import Features from "./landing/Features";
import Pipeline from "./landing/Pipeline";
import Audience from "./landing/Audience";
import Philosophy from "./landing/Philosophy";
import CTA from "./landing/CTA";
import Footer from "./landing/Footer";

export default function LandingApp() {
  return (
    <main className="relative">
      <Nav />
      <Hero />
      <Stats />
      <Features />
      <Pipeline />
      <Audience />
      <Philosophy />
      <CTA />
      <Footer />
    </main>
  );
}
